import { useNavigate } from 'react-router';

import { Button } from '@/components/Button';
import { Flex } from '@/layouts/Flex';
import styles from './styles.module.scss';

export function NotFoundPage() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1);
  };

  return (
    <Flex flexDirection='column' gap={20} justifyContent='center' alignItems='center' className={styles.container}>
      No hemos encontrado la página que buscas.
      <Button onClick={handleClick}>Volver</Button>
    </Flex>
  );
}
